import type {
  ElitePrimeInsights
} from '../../types/elitePrimeSummary.types'
import type { ElitePrimeAdvicePlanData } from './types/adviceCards.types'

export type { ElitePrimeAdvicePlanData } from './types/adviceCards.types'

export function resolveElitePrimeAdvicePlanData(
  elitePrimeInsights?: ElitePrimeInsights | null
): ElitePrimeAdvicePlanData {
  return {
    allocationPlanData: elitePrimeInsights?.allocationPlanData,
    allocationSipPlanData: elitePrimeInsights?.allocationSipPlanData,
    idealPortfolioData: elitePrimeInsights?.idealPortfolioData,
    idealSipData: elitePrimeInsights?.idealSipData,
    strategyData: elitePrimeInsights?.strategyData
  }
}
